// API client
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const apiClient = axios.create({ baseURL: API_BASE });
apiClient.interceptors.request.use((config) => {
  const code = localStorage.getItem("sne_access_code");
  if (code) config.headers["X-Access-Code"] = code;
  return config;
});

export default apiClient;
